import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import FileUploadModule from './file-select-and-drop-file';
import { RootState } from '../../../store/root-reducer';

const FileUploadModuleContainer: React.FC = memo(() => {
  const currentPlanName = useSelector(
    (state: RootState) => state?.home?.subscription?.planName,
  );
  const getEmailVerificationPlanResponse = useSelector(
    (state: RootState) =>
      state?.billingAndSubscription?.getEmailVerificationPlanResponse,
  );

  const sendPurchaseEmailVerificationCreditsRequestStatus = useSelector(
    (state: RootState) =>
      state?.billingAndSubscription.purchaseEmailVerificationCreditsRequest
        .status,
  );

  const sendGetEmailVerificationPlansRequestStatus = useSelector(
    (state: RootState) =>
      state?.billingAndSubscription.getEmailVerificationPlanRequest.status,
  );

  const sendGetEmailVerificationCreditsRequest = useSelector(
    (state: RootState) =>
      state?.billingAndSubscription.getEmailVerificationCreditsRequest.status,
  );

  const getPurchaseEmailVerificationCreditsResponse = useSelector(
    (state: RootState) =>
      state?.billingAndSubscription.purchaseEmailVerificationCreditsResponse,
  );
  const sendPurchaseEmailVerificationCreditsRequestMessage = useSelector(
    (state: RootState) =>
      state?.billingAndSubscription.purchaseEmailVerificationCreditsRequest
        .message,
  );

  const emailVerifyCredits = useSelector(
    (state: RootState) =>
      state?.billingAndSubscription?.getEmailVerificationCreditsResponse,
  );

  return (
    <FileUploadModule
      currentPlanName={currentPlanName}
      getEmailVerificationPlanResponse={getEmailVerificationPlanResponse}
      sendPurchaseEmailVerificationCreditsRequestStatus={
        sendPurchaseEmailVerificationCreditsRequestStatus
      }
      sendGetEmailVerificationPlansRequestStatus={
        sendGetEmailVerificationPlansRequestStatus
      }
      sendGetEmailVerificationCreditsRequest={
        sendGetEmailVerificationCreditsRequest
      }
      getPurchaseEmailVerificationCreditsResponse={
        getPurchaseEmailVerificationCreditsResponse
      }
      sendPurchaseEmailVerificationCreditsRequestMessage={
        sendPurchaseEmailVerificationCreditsRequestMessage
      }
      emailVerifyCredits={emailVerifyCredits}
    />
  );
});

export default FileUploadModuleContainer;
